// Fallback defaults used only while the business settings query is loading.
// The source of truth is the per-business policy (useBusinessSettings:
// waitlist_capacity and the waitlist_auto_promote_cutoff value + unit pair,
// read through shared/utils/cutoff.ts). Do not hardcode these into
// "full"/"closed" checks — read the configured values instead.
export const WAITLIST_CAP = 10;
export const WAITLIST_AUTO_PROMOTE_CUTOFF_MINUTES = 0;
